import { put, takeLatest } from "redux-saga/effects";
import { Notify } from "../../../UIcomponent/NotificationManager";
import DashboardReq from "../../../Utility/Requester/DashboardReq";
import actions from "../../actions";

export default function* review() {
  yield takeLatest(
    actions.dashboard.openSession.OPEN_SESSION_REQUEST,
    function* ({ id }) {
      try {
        const response = yield DashboardReq.SessionJoin(id);

        yield put({
          type: actions.dashboard.openSession.OPEN_SESSION_SUCCESS,
        });

        if (response.data.URL) {
          yield window.location.replace(response.data.URL);
        }
      } catch (error) {
        yield Notify("error", error.response.data.message);
        yield put({
          type: actions.dashboard.openSession.OPEN_SESSION_ERROR,
        });
      }
    }
  );
}
